import React, { useEffect } from 'react';
import firebase from '../store/api/fbConfig';
import { isLoaded, isEmpty, useFirestoreSubscriptions, resolveFirestoreConfigs } from './firebaseState';

export const getFirebase = () => firebase;
export const useFirebase = () => firebase;
export const ReactReduxFirebaseProvider = ({ children }) => <>{children}</>;
export const reactReduxFirebase = () => next => next;
export const firebaseReducer = (state = {}) => state;
export const useFirebaseConnect = () => {};
export const useFirestoreConnect = configs => useFirestoreSubscriptions(configs);
export const withFirestore = Component => props => <Component {...props} firestore={firebase.firestore()} />;

export const firestoreConnect = configs => Component => {
  const FirestoreConnectedComponent = props => {
    const resolved = React.useMemo(() => resolveFirestoreConfigs(configs, props), [props]);
    useFirestoreSubscriptions(resolved, props);
    return <Component {...props} />;
  };

  FirestoreConnectedComponent.displayName = `firestoreConnect(${Component.displayName || Component.name || 'Component'})`;
  return FirestoreConnectedComponent;
};

export { isLoaded, isEmpty };
